// ABOUTME: NavBar cart button showing the active cart's item count as a badge.
// ABOUTME: Opens the cart drawer on click; renders nothing when the cart feature is disabled.

import { Badge, IconButton, ShoppingCartIcon } from '@ds/coolshop';
import { useIntl } from 'react-intl';

import { useCartContext } from './CartContext';

export function CartNavButton() {
    const { formatMessage } = useIntl();
    const cart = useCartContext();

    if (!cart || !cart.enabled) {
        return null;
    }

    return (
        <IconButton
            color="primary"
            aria-label={formatMessage({ id: 'cpq.cart.title', defaultMessage: 'Cart' })}
            onClick={cart.openDrawer}
        >
            <Badge badgeContent={cart.itemCount} color="secondary">
                <ShoppingCartIcon />
            </Badge>
        </IconButton>
    );
}
